var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUnNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    fillRule: "evenodd",
    d: "M50.645 30.126C44.067 31.03 39 36.673 39 43.5c0 4.659 2.36 8.766 5.949 11.192H12v-2.769l5.538-5.538V32.539c0-8.516 4.528-15.619 12.462-17.502v-1.883A4.148 4.148 0 0 1 34.154 9a4.148 4.148 0 0 1 4.154 4.154v1.883c7.171 1.702 11.56 7.67 12.337 15.09zM34.154 63a5.537 5.537 0 0 0 5.538-5.538H28.615A5.537 5.537 0 0 0 34.154 63z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    fillRule: "evenodd",
    d: "M63 43.5C63 49.299 58.299 54 52.5 54S42 49.299 42 43.5 46.701 33 52.5 33 63 37.701 63 43.5zm-10.281 5.688a1.094 1.094 0 1 0 0-2.188 1.094 1.094 0 0 0 0 2.188zm0-11.813c-.604 0-1.094.49-1.094 1.094v6.562a1.094 1.094 0 1 0 2.188 0V38.47c0-.604-.49-1.094-1.094-1.094z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnNotification);
export default __webpack_public_path__ + "static/media/ic_un_notification.3178f2006fd5d359fe5ac3ed43222002.svg";
export { ForwardRef as ReactComponent };